import React, { Component } from 'react'
import Icon from "../../../../common/icon/icon.component.jsx";
import { FormattedMessage } from "react-intl";
import ImageGallery from "../../../../common/image/gallery.component.jsx";
import SectionWrapper from "../../sectionwrapper.component.jsx";
class ImageGalleryContentSection extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            className: this.props.className || '',
            section: this.props.section || null,
            variables: this.props.variables || null,
            editable: this.props.editable || false,
            edition: this.props.edition || false,
            isPdf: this.props.isPdf || false,
            onEdit: this.props.onEdit || function () { },
            id: this.props.id || '',
        }
        this.renderImagesForPDF = this.renderImagesForPDF.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            section: nextProps.section || null,
            variables: nextProps.variables || null,
            isPdf: nextProps.isPdf || false,
            id: nextProps.id || '',
        })
    }

    renderImagesForPDF() {
        let images = this.getImagesToRender()
        let renderedImages = []

        let nbImages = images.length
        for (let i = 0; i < nbImages; i++) {
            let image = images[i]

            renderedImages.push(
                <div className={"col-3 text-center mb-1"}>
                    <img key={'imagePdf-' + i} className={"img-fluid my-auto"}
                        src={image.attributes.publicUrlBySize["150x150"]} /></div>)
        }
        return renderedImages
    }

    getImagesToRender() {
        const sectionCustomFieldDefinitionIds = this.state.section.attributes.content.customFieldDefinitionIds
        let customFieldImages = []

        if (!sectionCustomFieldDefinitionIds) {
            return this.state.section.attributes.content.images
        }

        for (let customFieldDefinitionId of sectionCustomFieldDefinitionIds) {
            const customFieldRelation = this.state.variables?.project?.customFieldRelations[customFieldDefinitionId]
            if (!customFieldRelation) {
                continue
            }

            for (let image of customFieldRelation) {
                customFieldImages.push(image)
            }
        }

        return this.state.section.attributes.content.images.concat(customFieldImages)
    }

    getImagesPerRowToRender() {
        const sectionCustomFieldDefinitionIds = this.state.section.attributes.content.customFieldDefinitionIds
        let imagesPerRow = this.state.section.attributes.content.imagesPerRow

        if(Array.isArray(sectionCustomFieldDefinitionIds) && sectionCustomFieldDefinitionIds.length > 0) {
            const customFieldValues = this.state.variables?.project?.customFieldValues[sectionCustomFieldDefinitionIds]
            const parsedJson = customFieldValues ? JSON.parse(customFieldValues) : ''
            imagesPerRow = parsedJson ? parsedJson.imagesPerRow : imagesPerRow
        }

        return imagesPerRow
    }

    render() {
        if (!this.state.section) {
            return <div />
        }
        const hide = this.state.editable ? '' : 'd-none'

        let content = <div className={hide}>
            <p className={"section-empty-message m-0 text-left"}>
                {this.state.section.attributes.internalName}
            </p>
            <p className={"section-empty-message"}>
                <Icon value={"images"} />
                <small className={"ml-2"}>
                    <FormattedMessage
                        id="templates.sections.image_gallery.empty_message"
                        defaultMessage="There is no image in this section"
                    />
                </small>
            </p>
        </div>
        if (this.state.isPdf) {
            content = <div className="row align-items-center">{this.renderImagesForPDF()}</div>
        } else if (this.getImagesToRender().length > 0) {
            content = <ImageGallery
                value={this.getImagesToRender()}
                disabled={this.state.editable}
                isPdf={this.state.isPdf}
                imagesPerRow={this.getImagesPerRowToRender()}
            />
        }

        return (
            <SectionWrapper
                id={this.state.id}
                section={this.state.section}
                onEdit={this.state.onEdit}
                editable={this.state.editable}
                variables={this.state.variables}
            >
                <div className="col-12">
                    {content}
                </div>
            </SectionWrapper>
        )
    }
}

export default ImageGalleryContentSection


// WEBPACK FOOTER //
// ./src/template/sections/content/image-gallery/section.component.jsx